import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { FinancialEntityBranch } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';

export interface FinancialEntityBranchParams extends DefaultHttpHeaders {
  financialEntityBranchCode: string;
  /** Identifier of the bank */
  financialEntityCode: string;
}

@Injectable()
export class FinancialEntityBranchService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  // tslint:disable max-line-length
  /**
   * Service for obtaining financial branch by code
   * Service for obtaining financial branch by code
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Application%20Utilities/getFinancialEntityBranchesByCode
   */
  financialEntityBranch(params: FinancialEntityBranchParams): Observable<FinancialEntityBranch> {
    const pathParams = {
      financialEntityBranchCode: params.financialEntityBranchCode,
    };
    const queryParams = {
      financialEntityCode: params.financialEntityCode,
    };

    return this.get<FinancialEntityBranch>({
      suffix: `/comeround/applicationUtilities/financialEntityBranch/${pathParams.financialEntityBranchCode}`,
      queryParams,
    });
  }
}
